import type { CommentBody } from '@liveblocks/client';

export const extractTextFromBody = (body: CommentBody | undefined): string => {
  if (typeof body === 'string') return body;
  if (body?.content && Array.isArray(body.content)) {
    return body.content
      .map((block) => {
        if (block.children && Array.isArray(block.children)) {
          return block.children
            .map((child) => {
              if ('text' in child && typeof child.text === 'string') {
                return child.text;
              }
              return '';
            })
            .join('');
        }
        return '';
      })
      .join('\n');
  }
  return '';
};
